module.exports = __webpack_public_path__ + "img/cityapp-logo.ed35bd53.png";